import { persistReducer as persistReducer$1 } from 'redux-persist';
export { default as localStorage } from 'redux-persist/lib/storage';
export { default as sessionStorage } from 'redux-persist/lib/storage/session';

const persistReducer = (config, reducer)=>{
    if (typeof window !== 'undefined' && window.document) {
        return persistReducer$1(config, reducer);
    }
    return reducer;
};

export { persistReducer };
//# sourceMappingURL=index.js.map
